import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { HisSearchResultComponent, HisUiService, HisNavigationService,
    HisNotificationService, HisAuthService, HisConfirmationService } from 'hisng';

import { CONFIRMATION_PDIALOG_KEY } from 'app/fs/res/common/component/confirmation-dialogs/confirmation-dialog.component';
import { ResearchInfrastructureService } from 'app/fs/res/research-infrastructure/service/research-infrastructure.service';
import { ResearchInfrastructureModuleOptions } from '../../research-infrastructure-module.options';

@Component( {
    selector: 'res-research-infrastructure-search-result',
    templateUrl: './research-infrastructure-search-result.component.html'
} )
export class ResearchInfrastructureSearchResultComponent implements OnInit {

    public readonly moduleOptions = ResearchInfrastructureModuleOptions;

    @ViewChild( HisSearchResultComponent, { static: true } ) searchResultComponent: HisSearchResultComponent;

    public showBackButton = false;

    constructor( private route: ActivatedRoute,
        private confirmationService: HisConfirmationService,
        private notificationService: HisNotificationService,
        private researchInfrastructureService: ResearchInfrastructureService,
        private hisUiService: HisUiService,
        public auth: HisAuthService,
        public navigationService: HisNavigationService ) {
    }

    ngOnInit() {
        this.route.queryParams.subscribe( ( queryParams: any ) => {
            this.showBackButton = queryParams.showBackButton ? queryParams.showBackButton === 'true' : this.showBackButton;
        } );
    }

    /* callback to set last window location href */
    public onBeforeNavigate() {
        this.navigationService.setLastBackUrl( window.location.href );
    }

    /* delete selected row/entry from database */
    deleteRow( researchInfrastructureRow: any ) {
        this.confirmationService.confirm( {
            key: CONFIRMATION_PDIALOG_KEY,
            message: this.hisUiService.translate(
                'fs.res.researchInfrastructure.confirmDeleteResearchInfrastructure',
                researchInfrastructureRow.get( 'ResearchInfrastructure.title' ) ),
            accept: () => {
                let riId = researchInfrastructureRow.get( 'ResearchInfrastructure.id' );
                this.researchInfrastructureService.deleteResearchInfrastructure( riId ).subscribe( (deleteSuccess: number) => {
                    if ( deleteSuccess === 1 ) {
                        this.notificationService.deleteSuccessI18nRes();
                        this.searchResultComponent.reloadPageAfterDelete();
                    }
                } );
            }
        } );
    }
}
